import { createFileRoute } from '@tanstack/react-router';
import { DppSupplyChainTab } from '@/app/(client)/my-styles/-components/DppSupplyChainTab';
import { isEntityKindPath } from '@/app/(client)/my-styles/-hooks/useEntityDetail';

export const Route = createFileRoute(
  '/(client)/my-components/(pages)/(detail)/$kind/$id/supply-chain',
)({
  component: DppSupplyChainRoute,
});

function DppSupplyChainRoute() {
  const { kind, id } = Route.useParams();
  if (!isEntityKindPath(kind)) return null;
  return <DppSupplyChainTab kind={kind} id={id} />;
}
